export enum enumAttribute {
  'Action' = 6010,
  'VAT' = 6020,
  'Tax' = 6030,
  'Fee' = 6040,
  'Income-GL' = 6041,
  'VAT-GL' = 6042,
  'Tax-GL' = 6043,
  'Expense-GL0' = 6044
}

export namespace enumAttribute {
  export function values() {
    return Object.keys(enumAttribute).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
